import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DmpAdminRoutingModule} from './admin-routing.module';
import {PagesModule} from './pages/pages.module';
import {LayoutModule} from './layout/layout.module';
import {SettingsModule} from './pages/settings/settings.module';
import {TranslateModule} from '@ngx-translate/core';
import {KeycloakService} from 'keycloak-angular';


export function kcFactory(keycloakService: KeycloakService): () => void {
    return () => keycloakService.init({
        config: {
            url: 'http://localhost:9080/auth/',
            realm: 'jhipster',
            clientId: 'web_app'
        },
        // https://stackoverflow.com/questions/72019588/how-to-avoid-timeout-when-waiting-for-3rd-party-check-iframe-message-with-keyc
        initOptions: {
            pkceMethod: 'S256',
            checkLoginIframe: false,
            redirectUri: 'http://localhost:4200',
        }
    });
}

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        DmpAdminRoutingModule,
        PagesModule,
        SettingsModule,
        TranslateModule
    ],
    exports: [PagesModule, LayoutModule]
})
export class DmpAdminModule { }
